import { gql } from "@apollo/client";

export default gql`
  mutation rollbackLiveChatWidgetRelease($input: RollbackLiveChatWidgetReleaseInput!){
    rollbackLiveChatWidgetRelease(input: $input){
        success
        data{
            _id
            version
            note
            status
            source
            restoredFrom
            bucket
            prefix
            archivePrefix
            distributionId
            cdnUrl
            files{
                path
                size
                contentType
            }
            removedKeys
            invalidationId
            invalidationStatus
            healthCheckUrl
            healthCheckStatus
            errorMessage
            publishedBy
            createdAt
            updatedAt
        }
        error
        message
    }
}
`
